module.exports = __webpack_public_path__ + "img/igigi.b6b1d4ed.jpg";